import qs from 'qs'

/** @type {import('vue').ComponentOptions } */
const subCategoriesMixin = {
  props: {
    category: {
      type: Object,
      required: true
    },
    isProCert: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOtherCategory() {
      return this.category.id === 15
    },
    isFortuneCategory() {
      return this.category.id === 3
    }
  },
  methods: {
    /** カテゴリページ遷移先ルート */
    categoryRoute(
      category,
      isNuxtLink = true,
      isFromSearchService = false,
      isBusinessBeforeLogin = false
    ) {
      const query = {}
      if (!isFromSearchService) {
        query.ref = 'top_categories'
      } else {
        query.ref_c = 1
      }
      if (this.isProCert) {
        query.pro_priority_display = 1
      }
      if (isBusinessBeforeLogin) {
        query.is_business = 1
      }

      if (isNuxtLink) {
        const route = {
          name: 'categories-categoryId',
          params: {
            categoryId: category.id
          },
          query
        }
        return route
      }

      return (
        '/categories/' +
        category.id +
        (Object.values(query).length ? '?' + qs.stringify(query) : '')
      )
    },
    /** 親カテゴリリンク遷移先ルート */
    parentCategoryRoute(
      isNuxtLink = true,
      isFromSearchService = false,
      isBusinessBeforeLogin = false
    ) {
      const query = {
        pro_priority_display: 1
      }
      if (!isFromSearchService) {
        query.ref = 'top_categories'
        query.search_form = 'sidebar_category_pc'
      } else {
        query.ref_c = 1
      }
      if (isBusinessBeforeLogin) {
        query.is_business = 1
      }

      if (isNuxtLink) {
        if (this.isProCert) {
          return {
            name: 'search',
            query
          }
        }
        return this.categoryRoute(this.category, true, false, isBusinessBeforeLogin)
      }

      if (this.isProCert) {
        return '/search' + (Object.values(query).length ? '?' + qs.stringify(query) : '')
      }
      return this.categoryRoute(this.category, false, isFromSearchService, isBusinessBeforeLogin)
    },
    phoneConsultationServiceListRoute(
      isNuxtLink = true,
      isFromSearchService = false,
      isBusinessBeforeLogin = false
    ) {
      const query = {
        service_kind: 1
      }
      if (!isFromSearchService) {
        query.ref = 'top_categories'
      } else {
        query.ref_c = 1
      }
      if (isBusinessBeforeLogin) {
        query.is_business = 1
      }

      if (isNuxtLink) {
        return {
          name: 'categories-categoryId',
          params: {
            categoryId: this.category.id
          },
          query
        }
      }

      return '/categories/' + this.category.id + '?' + qs.stringify(query)
    }
  }
}
export default subCategoriesMixin
